/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VolumeStat
 */
export interface VolumeStat {
    /**
     * 
     * @type {number}
     * @memberof VolumeStat
     */
    time: number;
    /**
     * 
     * @type {number}
     * @memberof VolumeStat
     */
    cTotal: number;
    /**
     * 
     * @type {number}
     * @memberof VolumeStat
     */
    cUsed: number;
}

export function VolumeStatFromJSON(json: any): VolumeStat {
    return VolumeStatFromJSONTyped(json, false);
}

export function VolumeStatFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolumeStat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': json['time'],
        'cTotal': json['c_total'],
        'cUsed': json['c_used'],
    };
}

export function VolumeStatToJSON(value?: VolumeStat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': value.time,
        'c_total': value.cTotal,
        'c_used': value.cUsed,
    };
}


